<template>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm" @keyup.enter.native="submitForm('ruleForm')">
        <el-form-item prop="username">
            <el-input placeholder="请输入用户名" v-model="ruleForm.username">
                <template slot="prepend"><i class="el-icon-user-solid"></i></template>
            </el-input>
        </el-form-item>
        <el-form-item prop="password">
            <el-input placeholder="请输入密码" type="password" v-model="ruleForm.password" autocomplete="off">
                <template slot="prepend"><i class="el-icon-lock"></i></template>
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            name: 'Login',
            ruleForm:{
                username:'',
                password:'',
            },
            rules:{
                username:[
                    {required: true, message: '请输入用户名', trigger: 'blur'},
                    {min:3,message:'用户名长度错误',trigger:'blur'},
                ],
                password:[
                    {required: true, message: '请输入密码', trigger: 'blur'},
                ]
            },
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if(valid) {
                    this.$http.post('/manage/login',this.ruleForm).then(data => {
                        if(data['data'].code == 0) {
                            localStorage.setItem('name',this.ruleForm.username);
                            let navigat = JSON.parse(JSON.stringify(data['data']['data']['grants']));
                            
                            // 追加新增的菜单 - 安装工单管理和安装师傅管理
                            // const newMenus = this.getMockMenus();
                            // navigat = navigat.concat(newMenus);
                            
                            // // 修改grants数据，添加新菜单
                            // data['data']['data']['grants'] = navigat;
                            
                            this.$store.commit('loginIn',data['data']['data']); //触发store.js 中的loginIn 方法
                            localStorage.setItem('navigat',JSON.stringify(navigat));
                            this.$router.push('/home');
                        }else {
                            this.$message.error(data['data'].message);
                        }
                    }).catch(() => {
                        return false;
                    });
                }else {
                    return false;
                }
            });
        },
        // 获取Mock菜单数据 - 安装设备管理
        getMockMenus() {
            return [
                // 安装设备 - 一级菜单
                {
                    id: 9001,
                    pid: 0,
                    tid: 0,
                    directory: 'install',
                    title: '安装设备',
                    layout: null,
                    redirect: '/install/engineer/index',
                    component: null,
                    path: null
                },
                // 安装设备 -> 安装师傅 - 二级菜单
                {
                    id: 9002,
                    pid: 9001,
                    tid: 9001,
                    directory: 'engineer',
                    title: '安装师傅',
                    layout: 'layout',
                    redirect: '/install/engineer/index',
                    component: '/install/engineer/index',
                    path: 'index'
                },
                // 安装师傅 - 编辑页（不显示在菜单，但需要路由）
                {
                    id: 9003,
                    pid: 9002,
                    tid: 9002,
                    directory: 'edit',
                    title: '师傅编辑',
                    layout: null,
                    redirect: null,
                    component: '/install/engineer/edit',
                    path: 'edit'
                },
                // 安装设备 -> 安装工单 - 二级菜单
                {
                    id: 9004,
                    pid: 9001,
                    tid: 9001,
                    directory: 'bill',
                    title: '安装工单',
                    layout: 'layout',
                    redirect: '/install/bill/index',
                    component: '/install/bill/index',
                    path: 'index'
                },
                // 安装工单 - 编辑页（不显示在菜单，但需要路由）
                {
                    id: 9005,
                    pid: 9004,
                    tid: 9004,
                    directory: 'edit',
                    title: '工单编辑',
                    layout: null,
                    redirect: null,
                    component: '/install/bill/edit',
                    path: 'edit'
                },
                // 安装工单 - 详情页（不显示在菜单，但需要路由）
                {
                    id: 9006,
                    pid: 9004,
                    tid: 9004,
                    directory: 'detail',
                    title: '工单详情',
                    layout: null,
                    redirect: null,
                    component: '/install/bill/detail',
                    path: 'detail'
                },
                // 安装设备 -> 安装公司 - 二级菜单
                {
                    id: 9007,
                    pid: 9001,
                    tid: 9001,
                    directory: 'company',
                    title: '安装公司',
                    layout: 'layout',
                    redirect: '/install/company/index',
                    component: '/install/company/index',
                    path: 'index'
                },
                // 安装公司 - 编辑页（不显示在菜单，但需要路由）
                {
                    id: 9008,
                    pid: 9007,
                    tid: 9007,
                    directory: 'edit',
                    title: '公司编辑',
                    layout: null,
                    redirect: null,
                    component: '/install/company/edit',
                    path: 'edit'
                }
            ];
        }
    },
    mounted() {
        document.getElementsByTagName('body')[0].style.backgroundColor = 'rgb(48, 65, 86)';
    },
    beforeDestroy() {
        document.getElementsByTagName('body')[0].style.backgroundColor = '';
    },
}
</script>

<style>
</style>

<style scoped>
form{width: 400px; margin: 200px auto 0 auto;}
form button{width: 100%;}
.el-input__inner{border-color: #DCDFE6!important;}
</style>